import React, { useEffect, useState } from "react";

export default function AdminProiecteNeaprobate() {
  const [proiecte, setProiecte] = useState([]);
  const [membri, setMembri] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [actionLoading, setActionLoading] = useState(false);
  const [actionError, setActionError] = useState("");

  // Fetch toate proiectele (fără filtru)
  const fetchProiecte = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch(
        "https://prdp-api.suport-949.workers.dev/api/proiecte",
        {
          headers: { Authorization: "Bearer unwantedtok" },
        }
      );
      const data = await res.json();
      if (res.ok) {
        setProiecte(data);
      } else {
        setError(data.error || "Eroare la încărcarea proiectelor.");
      }
    } catch {
      setError("Eroare de rețea la încărcarea proiectelor.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch membri (toți pentru datele inițiatorilor)
  const fetchMembri = async () => {
    try {
      const res = await fetch("https://prdp-api.suport-949.workers.dev/api/membri", {
        headers: { Authorization: "Bearer unwantedtok" },
      });
      const data = await res.json();
      if (res.ok) {
        setMembri(data);
      } else {
        setMembri([]);
      }
    } catch {
      setMembri([]);
    }
  };

  useEffect(() => {
    fetchProiecte();
    fetchMembri();
  }, []);

  // Găsește inițiatorul după id in membri
  const gasesteInitiator = (idMembru) => {
    const membru = membri.find((m) => m.id === idMembru);
    if (!membru) return { nume: "N/A", prenume: "" };
    return { nume: membru.nume, prenume: membru.prenume };
  };

  const acceptaProiect = async (id) => {
    setActionLoading(true);
    setActionError("");
    try {
      const res = await fetch(
        `https://prdp-api.suport-949.workers.dev/api/proiecte/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer unwantedtok",
          },
          body: JSON.stringify({ aprobat_bn: 1 }),
        }
      );
      const data = await res.json();
      if (data.success) {
        fetchProiecte();
      } else {
        setActionError(data.error || "Eroare la aprobarea proiectului.");
      }
    } catch {
      setActionError("Eroare de rețea la aprobarea proiectului.");
    } finally {
      setActionLoading(false);
    }
  };

  const stergeProiect = async (id) => {
    if (!window.confirm("Sigur doriți să ștergeți acest proiect?")) return;
    setActionLoading(true);
    setActionError("");
    try {
      const res = await fetch(
        `https://prdp-api.suport-949.workers.dev/api/proiecte/${id}`,
        {
          method: "DELETE",
          headers: { Authorization: "Bearer unwantedtok" },
        }
      );
      const data = await res.json();
      if (data.success) {
        fetchProiecte();
      } else {
        setActionError(data.error || "Eroare la ștergerea proiectului.");
      }
    } catch {
      setActionError("Eroare de rețea la ștergerea proiectului.");
    } finally {
      setActionLoading(false);
    }
  };

  // Filtrare proiecte neaprobate înainte de afișare
  const proiecteNeaprobate = proiecte.filter((p) => p.aprobat_bn === 0);

  return (
    <div style={{ maxWidth: 1000, margin: "40px auto", padding: 20 }}>
      <h2>Proiecte neaprobate de BN</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {actionError && <p style={{ color: "red" }}>{actionError}</p>}
      {loading ? (
        <p>Se încarcă proiectele...</p>
      ) : proiecteNeaprobate.length === 0 ? (
        <p>Nu există proiecte neaprobate.</p>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ borderBottom: "1px solid #ccc", padding: 10, textAlign: "left" }}>
                Titlu
              </th>
              <th style={{ borderBottom: "1px solid #ccc", padding: 10, textAlign: "left" }}>
                Inițiator
              </th>
              <th style={{ borderBottom: "1px solid #ccc", padding: 10, textAlign: "left" }}>
                Descriere scurtă
              </th>
              <th style={{ borderBottom: "1px solid #ccc", padding: 10, textAlign: "left" }}>
                Descriere lungă
              </th>
              <th style={{ borderBottom: "1px solid #ccc", padding: 10, textAlign: "center" }}>
                Acțiuni
              </th>
            </tr>
          </thead>
          <tbody>
            {proiecteNeaprobate.map((p) => {
              const init = gasesteInitiator(p.id_membru_initiaza);
              return (
                <tr key={p.id}>
                  <td style={{ borderBottom: "1px solid #eee", padding: 10 }}>{p.titlu}</td>
                  <td style={{ borderBottom: "1px solid #eee", padding: 10 }}>
                    {init.prenume} {init.nume}
                  </td>
                  <td style={{ borderBottom: "1px solid #eee", padding: 10 }}>{p.descriere_scurta}</td>
                  <td style={{ borderBottom: "1px solid #eee", padding: 10 }}>{p.descriere_lunga || "-"}</td>
                  <td
                    style={{
                      borderBottom: "1px solid #eee",
                      padding: 10,
                      textAlign: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <button
                      onClick={() => acceptaProiect(p.id)}
                      disabled={actionLoading}
                      style={{
                        marginRight: 8,
                        backgroundColor: "#4caf50",
                        border: "none",
                        color: "white",
                        padding: "6px 12px",
                        borderRadius: 4,
                        cursor: "pointer",
                      }}
                    >
                      Acceptă
                    </button>
                    <button
                      onClick={() => stergeProiect(p.id)}
                      disabled={actionLoading}
                      style={{
                        backgroundColor: "#e53935",
                        border: "none",
                        color: "white",
                        padding: "6px 12px",
                        borderRadius: 4,
                        cursor: "pointer",
                      }}
                    >
                      Șterge
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}
